export class MasterDTO {
    id!: number;
    name?: string;
    description?: string;
    sortOrder?: number;
    isActive?: boolean;
    PerformanceCriteria?: any[];
    isTestOfficial?: boolean;
  }